// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q2-5";
export var filledCircle = "_q2-4";
export var historyEntry = "_q2-3";
export var messageSideLeft = "_q2-1";
export var messageSideRight = "_q2-2";
export var orderTrackingCarouselWrapper = "_q2-6";
export var orderTrackingInfoContainer = "_q2-0";